import { Component, OnInit, ViewChild } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { SocialAuthService } from 'src/app/services/authentication/social-auth.service';
import { EventsService } from 'src/app/services/event/event.service';

@Component({
  selector: 'app-signup-options-step-two',
  templateUrl: './signup-options-step-two.component.html',
  styleUrls: ['./signup-options-step-two.component.scss'],
})

export class SignupOptionsStepTwoComponent implements OnInit {

  public playAsGuestEnabled: boolean = false;

  public appleAuthEnabled: boolean = false;
  public fbAuthEnabled: boolean = false;
  public googleAuthEnabled: boolean = false;

  public generatedCSRF;
  public storeServerCSRFToken;
  public error: any = null;
  public isPlayerFirstVisit: boolean = null;
  public isPlayerLoggedInAsGuest: boolean = false;
  public platformID;

  constructor(
    private readonly appStorageService: AppstorageTsService,
    private readonly eventsService: EventsService,
    private readonly navigator: Navigator,
    private readonly socialAuth: SocialAuthService
  ) {
  }

  ngOnInit() {
    this.playAsGuestEnabled = this.socialAuth?.playAsGuestEnabled;
    this.appleAuthEnabled = this.socialAuth?.appleAuthEnabled;
    this.fbAuthEnabled = this.socialAuth?.fbAuthEnabled;
    this.googleAuthEnabled = this.socialAuth?.googleAuthEnabled;

    this.isFirstTimeAppLaunch();

    this.eventsService.subscribe("events:social:auth:error", (data) => {
      this.error = data;
      if(data.code === "CUSTOMER_EXCLUDED_BY_AUTHORITY"){
				this.error.setErrorMessage("Unfortunately, there is an error - you can’t play on this site.")
			}
    });

    this.appStorageService.getPlayerAsGuest().then((isGuest) => {
      if (isGuest.value === 'true') return this.isPlayerLoggedInAsGuest = true;
      return this.isPlayerLoggedInAsGuest = false;
    })
  }

  ngOnDestroy() {
    this.error = null;
    this.eventsService.unsubscribe("events:social:auth:error");
  }

  async isFirstTimeAppLaunch() {
    this.platformID = (await this.appStorageService.getPlayerPlatformID()).value;
    (this.platformID !== null) ? this.isPlayerFirstVisit = false : this.isPlayerFirstVisit = true;
  }

  public doPlayAsGuestCall(): any {
    return this.navigator.navigateTo("GuestPlayerTocComponent", { customModalClass: 'crown-modal', multipleModals: true });
  }

  public navigateTo(page: string, data): any {
    return this.navigator.navigateTo(page, data);
  }

  navigateToStepOne() {
    return this.navigator.navigateTo("SignupStepOneComponent", { customModalClass: 'crown-modal', multipleModals: true });
  }

  protected doSocialLogin(context) {
    this.navigator.navigateTo('SocialPlayerTocComponent', { customModalClass: 'crown-modal', multipleModals: true }, { data: context });
  }

  private socialLoginDirect(context: string): void {

    switch (context) {
      case 'apple':
        this.socialAuth.appleLogin(this.isPlayerLoggedInAsGuest);
        break;
      case 'fb':
        this.socialAuth.fbLogin(this.isPlayerLoggedInAsGuest);
        break;
      case 'google':
        this.socialAuth.googleLogin(this.isPlayerLoggedInAsGuest);
        break;
    }

  }

}